import { Switch } from "@/components/ui/switch";
import { ItemsEditor } from "@/components/common";
import { cn } from "@/lib/utils";

const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export const EMPTY_STANDING = { active: false, days: [0, 1, 2, 3, 4, 5, 6], items: [] };

export const standingText = (s, products = []) => {
  if (!s?.active) return "";
  const items = s.items.map((i) => `${products.find((p) => p.id === i.product_id)?.name || "Item"} × ${i.qty}`).join(", ");
  const days = s.days.length === 7 ? "every day" : [...s.days].sort().map((d) => DAYS[d]).join(", ");
  return `${items} · ${days}`;
};

export function StandingEditor({ value, onChange, products, prefix = "standing" }) {
  const v = value || EMPTY_STANDING;
  const toggleDay = (d) => onChange({ ...v, days: v.days.includes(d) ? v.days.filter((x) => x !== d) : [...v.days, d] });
  return (
    <div className="space-y-3" data-testid={`${prefix}-editor`}>
      <label className="flex items-center justify-between gap-3 rounded-xl border border-[#E7E2D6] bg-white p-3">
        <div>
          <div className="font-semibold text-sm">Regular (standing) order</div>
          <div className="text-xs text-muted-foreground">Auto-confirmed on the chosen days. No need to reply every day.</div>
        </div>
        <Switch checked={v.active} onCheckedChange={(active) => onChange({ ...v, active })} data-testid={`${prefix}-toggle`} />
      </label>
      {v.active && (
        <>
          <div className="flex flex-wrap gap-1.5">
            {DAYS.map((d, i) => (
              <button type="button" key={d} onClick={() => toggleDay(i)} data-testid={`${prefix}-day-${i}`}
                className={cn("h-9 min-w-[44px] rounded-full border px-3 text-xs font-semibold transition-colors",
                  v.days.includes(i) ? "border-[#0F382C] bg-[#0F382C] text-white" : "border-[#E7E2D6] bg-white text-slate-600")}>
                {d}
              </button>
            ))}
          </div>
          <ItemsEditor products={products} value={v.items} onChange={(items) => onChange({ ...v, items })} prefix={prefix} />
        </>
      )}
    </div>
  );
}
